import { useEffect, useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { trackPageView } from '../analytics/visitor';

/**
 * Records a pageview on first mount and when the hash/path changes.
 */
const VisitorTracker = () => {
  const { lang } = useLanguage();
  const lastKey = useRef('');

  useEffect(() => {
    const send = () => {
      const key = `${window.location.pathname}${window.location.hash}|${lang}`;
      if (key === lastKey.current) return;
      lastKey.current = key;
      trackPageView({ language: lang });
    };

    send();
    window.addEventListener('hashchange', send);
    return () => window.removeEventListener('hashchange', send);
  }, [lang]);

  return null;
};

export default VisitorTracker;
